export function formatMoney(value: number): string {
  return `¥${value.toFixed(2)}`;
}
